import {ImageBackground, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalBackgroundBaseSettings} from "./PortalBackgroundBaseSettings";

export class PortalImageBackground extends ImageBackground implements Parameter {
	constructor(data: any) {
		super(data);

		this.settings = PortalBackgroundBaseSettings.fromJson(data?.settings);
	}

	public static fromJson(data: any): PortalImageBackground {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalImageBackground(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'settings': this.settings?.toJson()
		};
	}

	public clone(): PortalImageBackground {
		return PortalImageBackground.fromJson(this.toJson());
	}
}